import moment from 'moment';

export const buildAddress = (resumeData) => {
  const { address, city, country, zipcode } = resumeData;
  return [address, city, country, zipcode]
    .filter(Boolean)
    .map(item => item.toUpperCase())
    .join(', ');
};

export const getDateOfBirth = (dateOfBirth) => {
  return dateOfBirth ? moment(dateOfBirth).format("MMMM DD, YYYY") : "";
};

export const getAboveTitleItems = (resumeData) => {
  const { dateOfBirth, driversLicense, nationality, phoneNumber, email } = resumeData;
  const formattedDOB = getDateOfBirth(dateOfBirth);
  return [buildAddress(resumeData), formattedDOB, driversLicense, nationality, phoneNumber, email].filter(Boolean);
};

export const buildLanguages = (resumeData) => {
  const { languages } = resumeData;
  if (!languages) return "";
  return languages
    .filter(lang => !!lang.name)
    .map(lang => `${lang.name}${lang.proficiency ? ` (${lang.proficiency})` : ''}`)
    .join(', ');
};

export const buildSkills = (resumeData) => {
  const { skills } = resumeData;
  if (!skills) return "";
  return skills
    .filter(skill => !!skill.name)
    .map(skill => `${skill.name}${skill.level ? ` (${skill.level})` : ''}`)
    .join(', ');
}; 